module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.seen) ? _c('div', {
    staticClass: "banner",
    class: {
      active: _vm.isActive, 'isDone': _vm.isDone
    }
  }, [_c('div', {
    staticClass: "banner-header"
  }, [_c('div', {
    staticClass: "banner-header__text pointer"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.isActive = !_vm.isActive
      }
    }
  }, [_c('span', {
    staticClass: "icon-play3"
  }), _vm._v(" VIDEO: Føj til startskærm")])]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.setSeen
    }
  }, [_c('span', {
    staticClass: "black-close box-shadow icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "banner-body"
  }, [_c('youtube', {
    attrs: {
      "video-id": _vm.videoid,
      "player-width": _vm.w,
      "player-height": _vm.h
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-708361c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/SiteWideAnnouncement.vue
// module id = 1713
// module chunks = 1